export default __webpack_public_path__ + "static/media/M9 - Waterfall Flash.d2c0b60a.png";